import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  width: "24",
  height: "24",
  fill: "none",
  viewBox: "0 0 24 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "M20.25 12.203q.006-.203 0-.405l1.399-1.748a.75.75 0 0 0 .139-.662c-.23-.862-.573-1.69-1.02-2.46a.75.75 0 0 0-.563-.37l-2.224-.247a8 8 0 0 0-.281-.281l-.262-2.23a.75.75 0 0 0-.37-.562 10 10 0 0 0-2.46-1.018.75.75 0 0 0-.663.139L12.203 3.75h-.405L10.05 2.354a.75.75 0 0 0-.662-.139c-.862.23-1.69.573-2.46 1.02a.75.75 0 0 0-.37.563l-.247 2.227a9 9 0 0 0-.281.282l-2.23.256a.75.75 0 0 0-.562.369c-.447.772-.79 1.6-1.019 2.46a.75.75 0 0 0 .14.663l1.391 1.742v.406L2.354 13.95a.75.75 0 0 0-.139.662c.23.862.573 1.69 1.02 2.46a.75.75 0 0 0 .563.37l2.224.247q.14.146.28.281l.26 2.23a.75.75 0 0 0 .37.562c.772.447 1.6.79 2.46 1.019a.75.75 0 0 0 .663-.14l1.742-1.391q.202.006.406 0l1.747 1.399a.75.75 0 0 0 .662.139 10 10 0 0 0 2.46-1.02.75.75 0 0 0 .37-.563l.247-2.224q.146-.138.281-.281l2.23-.262a.75.75 0 0 0 .562-.37c.447-.771.79-1.6 1.019-2.46a.75.75 0 0 0-.14-.663zM12 15.75a3.75 3.75 0 1 1 0-7.5 3.75 3.75 0 0 1 0 7.5"
    }, null, -1)
  ])))
}
export default { render: render }